
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    msg: String,
  },
})
export default class TheFooter extends Vue {
  msg!: string;
}
